import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-[1920px] mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold tracking-wider mb-4">POSITIV</h3>
            <p className="text-white/70 text-sm leading-relaxed">
              Die Fitness und Wellnessgruppe für höchste Ansprüche. Wo Luxus und Fitness aufeinandertreffen.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-all">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-all">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-all">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-black transition-all">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Schnellzugriff</h4>
            <ul className="space-y-3">
              {/* <li><Link to="/clubs" className="text-white/70 hover:text-white transition-colors text-sm">Clubs finden</Link></li> */}
              <li><Link to="/membership" className="text-white/70 hover:text-white transition-colors text-sm">Mitgliedschaft</Link></li>
              <li><Link to="/classes" className="text-white/70 hover:text-white transition-colors text-sm">Kurse</Link></li>
              <li><Link to="/personal-training" className="text-white/70 hover:text-white transition-colors text-sm">Personal Training</Link></li>
              <li><Link to="/spa" className="text-white/70 hover:text-white transition-colors text-sm">Spa & Wellness</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Unternehmen</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-white/70 hover:text-white transition-colors text-sm">Über uns</a></li>
              {/* <li><a href="#" className="text-white/70 hover:text-white transition-colors text-sm">Karriere</a></li> */}
              {/* <li><a href="#" className="text-white/70 hover:text-white transition-colors text-sm">Presse</a></li> */}
              <li><a href="#" className="text-white/70 hover:text-white transition-colors text-sm">Partner</a></li>
              <li><a href="#" className="text-white/70 hover:text-white transition-colors text-sm">Kontakt</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Rechtliches</h4>
            <ul className="space-y-3">
              <li><Link to="/agb" className="text-white/70 hover:text-white transition-colors text-sm">AGB</Link></li>
              <li><Link to="/datenschutz" className="text-white/70 hover:text-white transition-colors text-sm">Datenschutz</Link></li>
              <li><Link to="/impressum" className="text-white/70 hover:text-white transition-colors text-sm">Impressum</Link></li>
              <li><a href="#" className="text-white/70 hover:text-white transition-colors text-sm">Cookie-Richtlinie</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-white/60 text-sm">
            © 2025 POSITIV - Die Fitness und Wellnessgruppe. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
